import Cookies from "js-cookie";
import moment from "moment";
import Swal from "sweetalert2";
import { RoutesLink } from "./RoutesLink";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";

// Api Url's for the API's
export const serverUrl = "https://devapi.mybilty.com/";
// export const serverUrl = "https://4dxf2015-3001.inc1.devtunnels.ms/";
//local server
// export const serverUrl = "https://7f074tk1-4200.inc1.devtunnels.ms/S0001/api/v1/";

// Api's Function

export const callApi = async (url, options) => {
  // dispatch(setLoading(true));

  // const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJmMDdlOTk4MS03NzM3LTRmNzYtODFiOS1hYTNhNzZkZTllMzkiLCJlbWFpbCI6InJhajE1MjFAZ21haWwuY29tIiwicGhvbmUiOm51bGwsImlhdCI6MTcyMDI0ODk4MCwiZXhwIjoxNzIwMzM1MzgwfQ.KSss2s7X1bTagGa0r-jJKlHHcsGhjMBVb3h6q4pstEI"
  const token = Cookies.get("token");
  let headers;
  const API = serverUrl + url;
  // options?.data ? headers = { "Content-Type": "application/json" } : "";
  if (options?.data) {
    headers = { "Content-Type": "application/json" };
  } else {
    headers = "";
  }
  // console.log(token)
  try {
    const raw = await fetch(API, {
      headers: {
        ...(token &&
          token !== undefined && { Authorization: `Bearer ${token}` }),
        ...headers,
        // "Content-Type": "application/json",
      },
      method: options?.method || "GET",
      body: options?.data
        ? JSON.stringify(options?.data)
        : options?.form_data
          ? options?.form_data
          : undefined,
    });
    // console.log("raw>>>>>>>>>",raw);

    const data = await raw.json();
    // console.log("api helper data", data);
    if (data?.message === "jwt expired" || data?.message == "invalid token") {
      window.location.replace(process.env.PUBLIC_URL + RoutesLink?.login);
      toast.error("Session expired, please login again");
      Cookies.remove("token");
      localStorage.clear();
      return;
    }


    // console.log("api error", data);
    if (!raw.ok) {

      throw new Error(data?.message);
    }
    return data;
  } catch (error) {
    // let errorStatus = JSON.parse(error.response);
    console.log("error>>>>>>>>>", error);

    return error;

    // return error;
  } finally {
    // dispatch(setLoading(false))
  }
};


export async function DownloadReportHandler(
  type,
  url,
  setIsLoading,
  method = "GET",
  data = null
) {
  Swal.fire({
    text: "Do you want to Download this file?",
    showDenyButton: true,
    showCancelButton: false,
    confirmButtonText: "Yes",
  }).then((result) => {
    let tokens = null;
    if (result.isConfirmed) {
      setIsLoading(true);
      if (Cookies.get("Jubel_token")) {
        tokens = Cookies.get("Jubel_token");
      }
      let headers = {
        Accept: "application/json",
        Authorization: "Bearer " + tokens,
        "Accept-Language": "en",
        "allow-access-origin": "*",
        "X-localization": "en",
        "Content-Type": "application/json",
      };

      let requestOptions = {
        method: method,
        headers: headers,
        body: data ? JSON.stringify(data) : null,
      };

      fetch(serverUrl + url, requestOptions)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.blob();
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          let date = moment(new Date()).format("DD-MM-YYYY-hh:mm:ss");
          let fileName = `${type}-${date}`;
          link.setAttribute("download", fileName); //or any other extension
          document.body.appendChild(link);
          link.click();
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setIsLoading(false);
        });
    }
  });
}

export const fetchAndDownloadFile = async (apiUrl, fileName, setLoading) => {
  const token = Cookies.get("token");
  const API = serverUrl + apiUrl;

  try {
    // Define the headers
    const headers = {
      'Authorization': `Bearer ${token}`, // Replace with your token logic
      'Accept': 'application/json',
    };
    setLoading(true);
    // Make the API call using fetch
    const response = await fetch(API, {
      method: 'GET',
      headers: headers
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    } else {
      setLoading(false);
    }

    // Parse the response as JSON to get the file URL
    const data = await response.json();
    const url = data?.data?.url; // Extract the file URL from the response

    if (!url) {
      throw new Error('No file URL found in the response');
    }

    // Create an anchor tag to open in a new tab and trigger download
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.target = '_blank'; // Open in a new tab
    anchor.download = fileName || 'Offer-Letter'; // Default file name if not provided
    document.body.appendChild(anchor); // Append to body to ensure click works
    anchor.click(); // Trigger the click event programmatically
    document.body.removeChild(anchor); // Remove after triggering download

    console.log('File downloaded successfully');
  } catch (error) {
    console.error('Error while downloading the file:', error);
    setLoading(false);
  }
};




